module.exports = __webpack_public_path__ + "static/media/bio_chem_2.cb15b101.JPG";